import React, { Component } from 'react'
import KeyLeftColumn from './leftColumn/KeyLeftColumn'
import KktLeftColumn from './leftColumn/KktLeftColumn'
import ServiceLeftColumn from './leftColumn/ServiceLeftColumn'
import KeyRightColumn from './rightColumn/KeyRightColumn'
import Noop from './Noop'
import Price from './price/Price'

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'kkt',
      register: 'atol90F',
      fiskal: false,
      activationCode: false,
      kktactivation: false,
      lkofdregistration: false,
      registrationwithoutfns: false,
      techicalsupport: false,
      po: false,
      ofdcode: false,
      abonent: false,
      docexpert: false,
      jacarta: false,
      signature: false,
      techicalLkFns: false,
      techicalLkOfd: false,
      fiskalizationAndFNS: false,
      connectOfd: false,
      kktSoft: false,
      delivery: false
    }

    this.handleModeSelect = this.handleModeSelect.bind(this)
    this.handleRegisterSelect = this.handleRegisterSelect.bind(this)
    this.changeFiskal = this.changeFiskal.bind(this)
    this.changeService = this.changeService.bind(this)
    this.changeActivationCode = this.changeActivationCode.bind(this)
  }
  handleModeSelect(event) {
    const mode = event.target.value
    this.setState(prevState => {
      return {mode: mode}
    })
    this.props.changeFieldinFormState('mode', {value: mode})
  }
  handleRegisterSelect(event) {
    const register = event.target.value
    this.setState(prevstate => {
      return {register: register}
    })
    this.props.changeFieldinFormState('register', {value: register})
  }
  changeFiskal(event) {
    const check = event.target.checked
    this.setState(prevState => {
      return {fiskal: check}
    })
    this.props.changeFieldinFormState('fiskal', {value: check})
  }
  changeService(event) {
    const check = event.target.checked
    const serviceName = event.target.name

    this.setState(prevState => {
      return {[serviceName]: check}
    })

    this.props.changeFieldinFormState(serviceName, {value: check})
  }
  changeActivationCode(event) {
    const code = event.target.checked
    this.setState(prevState => {
      return {activationCode: code}
    })

    this.props.changeFieldinFormState('activationCode', {value: code})
  }
  render() {
    let leftColumn = Noop
    let rightColumn = Noop

    switch(this.state.mode) {
      case 'key':
        leftColumn = KeyLeftColumn
        rightColumn = KeyRightColumn
        break
      case 'kkt':
        leftColumn = KktLeftColumn
        rightColumn = KeyRightColumn
        break
      case 'service':
        leftColumn = ServiceLeftColumn
        rightColumn = Noop
        break
      default:
        leftColumn = Noop
        rightColumn = Noop
        break
    }
    
    return (
      <div className="container">
        <div className="content">
        <h6 className="title is-5 has-text-centered"><span style={{fontWeight: 'bold', color: '#4fa800'}}>Выберите</span> комплект поставки из списка:</h6>
        <div className="has-text-centered">
          <select style={{marginLeft: '2px', fontSize: '18pt'}} value={this.state.mode} onChange={this.handleModeSelect}>
            <option value="key">«Под Ключ»</option>
            <option value="kkt">«Поставка только ККТ»</option>
            <option value="service">«Предоставление услуг»</option>
          </select>
        </div>

        {this.state.mode==='key' ? <h4 className="has-text-centered">(от поставки оборудования до запуска(первый чек))</h4>: null}


        <div className="tile is-ancestor" style={{marginTop: '2px'}}>
          <div className="tile is-vertical is-parent">
            { React.createElement(
                leftColumn,
                {
                  register: this.state.register,
                  handleRegisterSelect: this.handleRegisterSelect,
                  fiskal: this.state.fiskal,
                  changeFiskal: this.changeFiskal,
                  kktactivation: this.state.kktactivation,
                  lkofdregistration: this.state.lkofdregistration,
                  registrationwithoutfns: this.state.registrationwithoutfns,
                  techicalsupport: this.state.techicalsupport,
                  po: this.state.po,
                  ofdcode: this.state.ofdcode,
                  abonent: this.state.abonent,
                  docexpert: this.state.docexpert,
                  jacarta: this.state.jacarta,
                  signature: this.state.signature,
                  techicalLkFns: this.state.techicalLkFns,
                  techicalLkOfd: this.state.techicalLkOfd,
                  fiskalizationAndFNS: this.state.fiskalizationAndFNS,
                  connectOfd: this.state.connectOfd,
                  kktSoft: this.state.kktSoft,
                  delivery: this.state.delivery,
                  changeService: this.changeService,
                  activationCode: this.state.activationCode,
                  changeActivationCode: this.changeActivationCode
                }
              ) }
              
            <Price
                mode={this.state.mode}
                register={this.state.register}
                fiskal={this.state.fiskal}
                kktactivation={this.state.kktactivation}
                lkofdregistration={this.state.lkofdregistration}
                registrationwithoutfns={this.state.registrationwithoutfns}
                techicalsupport={this.state.techicalsupport}
                po={this.state.po}
                ofdcode={this.state.ofdcode}
                abonent={this.state.abonent}
                docexpert={this.state.docexpert}
                jacarta={this.state.jacarta}
                signature={this.state.signature}
                delivery={this.state.delivery}
                techicalLkFns={this.state.techicalLkFns}
                techicalLkOfd={this.state.techicalLkOfd}
                fiskalizationAndFNS={this.state.fiskalizationAndFNS}
                connectOfd={this.state.connectOfd}
                kktSoft={this.state.kktSoft}
                activationCode={this.state.activationCode}
              />
          </div>
          <div className="tile is-parent">
            { React.createElement(rightColumn, {register: this.state.register}) }
          </div>
        </div>

      </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/ofdCalc/App.js